import { QuoteFormConfigDTO } from '../DTO/QuoteFormConfigDTO';

// DEV ENV FOR DEBUG
// api_url: 'https://dev.fantasticxrm.com',
// token: '4rd4spxv8eg4tsl5l9bs4nmeh92i47z2fx8oyljnwcoqkq0kyxd74brtwgre3xj7',
// source_abbr: 'CarpCln_LasVegas',

export const clientConfigs: { [key: string]: QuoteFormConfigDTO } = {
    default: {
        id: 0,
        api_url: 'https://kollect.serviceos.com',
        token: 'ephvoioojo3wx4o66a0sgz7klc45wxp60qlqdq3mtqyiu67bbcm6zjo7mscrbsqj',
        source_abbr: 'Kollect_site_callback_IE',
        validation: {
            subject: /([^\s])/,
            client_name: /^(?!\s*$)[a-zA-Z.+\s\'-]+$/,
            client_phone:
                /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/,
            client_email:
                /([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,})+/i,
            client_postcode: /^(?=.*\S).+$/,
            comment: /([^\s])/,
        },
        captcha: {
            type: 'google',
            settings: {
                google: {
                    g_key: '6LcGE5gaAAAAAE4ba40iPqbxyMGyTCc9MZ5upScN',
                    // g_key: '6Lf93JkaAAAAAFFbLOl_NMTAARAox3CLshv5rkxq',
                    script: 'https://www.google.com/recaptcha/api.js',
                },
            },
        },
        layout: {
            type: 'side',
            description: '',
            title: 'Request a Quote',
            footer_text: '',
            submit_text: 'Thanks for submitting the form.',
            button_text: 'Submit',
            theme: {
                class: 'test-class',
                // background: '#ffffff',
                // accent: '#e83e8c',
                // accentContrastText: '#fff',
                // primary: "#005a96",
                // primaryContrastText: '#fff',
                // text: '#404040',
                // fieldsType: 'material'
                primary: '#f26930',
                primaryContrastText: '#fff',
                accent: '#f26930',
                accentContrastText: '#fff',
                text: '#ffffff',
                background: '#2e3c50',
                fieldsType: 'bootstrap',
            },
            fields: [
                // {
                //     required: true,
                //     error: false,
                //     error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                //     label: 'Service',
                //     default_value: '',
                //     name: 'subject',
                //     type: 'text-field',
                // },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'NAME',
                    placeholder: 'Name',
                    name: 'client_name',
                    type: 'text-field',
                },
                {
                    required: false,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS FIELD.',
                    label: 'EMAIL',
                    name: 'client_email',
                    placeholder: 'Email',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message:
                        'PLEASE ENTER A PHONE NUMBER THAT HAS AT LEAST 9 DIGITS.',
                    label: 'NUMBER',
                    placeholder: 'Phone number',
                    name: 'client_phone',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'CITY/TOWN',
                    placeholder: 'City',
                    name: 'client_postcode',
                    type: 'text-field',
                },
                // {
                //     required: true,
                //     error: false,
                //     error_message: '',
                //     label: 'Comment',
                //     name: 'comment',
                //     type: 'text-area',
                // },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: "I'M INTERESTED IN...",
                    default_value: '',
                    name: 'subject',
                    type: 'select-field',
                    options: [
                        { title: 'SKIPS', value: 'SKIPS' },
                        { title: 'JUNK REMOVAL', value: 'JUNK REMOVAL' },
                        { title: 'COMMERCIAL', value: 'COMMERCIAL' },
                        {
                            title: 'SINGLE ITEM REMOVAL',
                            value: 'SINGLE ITEM REMOVAL',
                        },
                        { title: 'SKIP BAGS', value: 'SKIP BAGS' },
                    ],
                },
                {
                    required: false,
                    error: false,
                    error_message: '',
                    label: 'Please select how you would like to receive promotions and special offers:',
                    name: 'preferences',
                    type: 'checkboxes',
                    options: [
                        { title: 'SMS', name: 'allow_mk_sms', value: false },
                        {
                            title: 'Email',
                            name: 'allow_mk_email',
                            value: false,
                        },
                    ],
                },
            ],
        },
    },
    uk: {
        id: 1,
        api_url: 'https://kollect.serviceos.com',
        token: 'ephvoioojo3wx4o66a0sgz7klc45wxp60qlqdq3mtqyiu67bbcm6zjo7mscrbsqj',
        source_abbr: 'Kollect_site_callback_UK',
        validation: {
            subject: /([^\s])/,
            client_name: /^(?!\s*$)[a-zA-Z.+\s\'-]+$/,
            client_phone:
                /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/,
            client_email:
                /([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,})+/i,
            client_postcode: /^(?=.*\S).+$/,
            comment: /([^\s])/,
        },
        captcha: {
            type: 'google',
            settings: {
                google: {
                    g_key: '6LeOhZ4aAAAAAEYxNqQgQuGoEidRyf6tH1gKJqpA',
                    script: 'https://www.google.com/recaptcha/api.js',
                },
            },
        },
        layout: {
            type: 'side',
            description: '',
            title: 'Request a Quote',
            submit_text: 'Thanks for submitting the form.',
            footer_text: '',
            button_text: 'Submit',
            theme: {
                class: 'test-class',
                primary: '#f26930',
                primaryContrastText: '#fff',
                accent: '#f26930',
                accentContrastText: '#fff',
                text: '#ffffff',
                background: '#2e3c50',
                fieldsType: 'bootstrap',
            },
            fields: [
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'NAME',
                    placeholder: 'Name',
                    name: 'client_name',
                    type: 'text-field',
                },
                {
                    required: false,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS FIELD.',
                    label: 'EMAIL',
                    name: 'client_email',
                    placeholder: 'Email',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message:
                        'PLEASE ENTER A PHONE NUMBER THAT HAS AT LEAST 9 DIGITS.',
                    label: 'NUMBER',
                    placeholder: 'Phone number',
                    name: 'client_phone',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'POSTCODE',
                    placeholder: 'Postcode',
                    name: 'client_postcode',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: "I'M INTERESTED IN...",
                    default_value: '',
                    name: 'subject',
                    type: 'select-field',
                    options: [
                        { title: 'SKIPS', value: 'SKIPS' },
                        { title: 'JUNK REMOVAL', value: 'JUNK REMOVAL' },
                        { title: 'COMMERCIAL', value: 'COMMERCIAL' },
                        {
                            title: 'SINGLE ITEM REMOVAL',
                            value: 'SINGLE ITEM REMOVAL',
                        },
                        { title: 'SKIP BAGS', value: 'SKIP BAGS' },
                    ],
                },
                {
                    required: false,
                    error: false,
                    error_message: '',
                    label: 'Please select how you would like to receive promotions and special offers:',
                    name: 'preferences',
                    type: 'checkboxes',
                    options: [
                        { title: 'SMS', name: 'allow_mk_sms', value: false },
                        {
                            title: 'Email',
                            name: 'allow_mk_email',
                            value: false,
                        },
                    ],
                },
            ],
        },
    },
    uk_popup: {
        id: 2,
        api_url: 'https://kollect.serviceos.com',
        token: 'ephvoioojo3wx4o66a0sgz7klc45wxp60qlqdq3mtqyiu67bbcm6zjo7mscrbsqj',
        source_abbr: 'Kollect_site_popup_UK',
        show_once_session: true,
        validation: {
            subject: /([^\s])/,
            client_name: /^(?!\s*$)[a-zA-Z.+\s\'-]+$/,
            client_phone:
                /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/,
            client_email:
                /([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,})+/i,
            client_postcode: /^(?=.*\S).+$/,
            comment: /([^\s])/,
        },
        captcha: {
            type: 'google',
            settings: {
                google: {
                    g_key: '6LeOhZ4aAAAAAEYxNqQgQuGoEidRyf6tH1gKJqpA',
                    script: 'https://www.google.com/recaptcha/api.js',
                },
            },
        },
        layout: {
            type: 'popup',
            description:
                "✨ HURRY...this week only we've a discount code to get you £10 off your online order!✨",
            title: 'Hi There 👋 FANCY £10 OFF??',
            submit_text:
                "Here's your £10 discount code, enter this code at the checkout: WELCOME10",
            button_text: 'GET MY DISCOUNT CODE NOW',
            footer_text:
                'DISCOUNT CODE IS REVEALED AFTER YOUR SUBMIT YOUR NUMBER',
            theme: {
                class: 'test-class',
                primary: '#f26930',
                primaryContrastText: '#fff',
                accent: '#f26930',
                accentContrastText: '#fff',
                text: '#ffffff',
                background: '#2e3c50',
                fieldsType: 'bootstrap',
            },
            fields: [
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: '',
                    placeholder: 'Name',
                    name: 'client_name',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message:
                        'PLEASE ENTER A PHONE NUMBER THAT HAS AT LEAST 9 DIGITS.',
                    label: '',
                    placeholder: 'Phone number',
                    name: 'client_phone',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: "I'M INTERESTED IN...",
                    default_value: '',
                    name: 'subject',
                    type: 'select-field',
                    options: [
                        { title: 'SKIPS', value: 'SKIPS' },
                        { title: 'JUNK REMOVAL', value: 'JUNK REMOVAL' },
                        { title: 'COMMERCIAL', value: 'COMMERCIAL' },
                        {
                            title: 'SINGLE ITEM REMOVAL',
                            value: 'SINGLE ITEM REMOVAL',
                        },
                        { title: 'SKIP BAGS', value: 'SKIP BAGS' },
                    ],
                },
                {
                    required: false,
                    error: false,
                    error_message: '',
                    label: 'Please select if you would like to receive promotions and special offers:',
                    name: 'preferences',
                    type: 'checkboxes',
                    options: [
                        { title: 'SMS', name: 'allow_mk_sms', value: false },
                    ],
                },
            ],
        },
    },
    ie_popup: {
        id: 4,
        api_url: 'https://kollect.serviceos.com',
        token: 'ephvoioojo3wx4o66a0sgz7klc45wxp60qlqdq3mtqyiu67bbcm6zjo7mscrbsqj',
        source_abbr: 'Kollect_site_popup_IE',
        show_once_session: true,
        validation: {
            subject: /([^\s])/,
            client_name: /^(?!\s*$)[a-zA-Z.+\s\'-]+$/,
            client_phone:
                /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/,
            client_email:
                /([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,})+/i,
            client_postcode: /^(?=.*\S).+$/,
            comment: /([^\s])/,
        },
        captcha: {
            type: 'google',
            settings: {
                google: {
                    g_key: '6LcGE5gaAAAAAE4ba40iPqbxyMGyTCc9MZ5upScN',
                    script: 'https://www.google.com/recaptcha/api.js',
                },
            },
        },
        layout: {
            type: 'popup',
            description:
                "✨ HURRY...this week only we've a discount code to get you €10 off your online order!✨",
            title: 'Hi There 👋 FANCY €10 OFF??',
            submit_text:
                "Here's your €10 discount code, enter this code at the checkout: WELCOME10",
            button_text: 'GET MY DISCOUNT CODE NOW',
            footer_text:
                'DISCOUNT CODE IS REVEALED AFTER YOUR SUBMIT YOUR NUMBER',
            theme: {
                class: 'test-class',
                primary: '#f26930',
                primaryContrastText: '#fff',
                accent: '#f26930',
                accentContrastText: '#fff',
                text: '#ffffff',
                background: '#2e3c50',
                fieldsType: 'bootstrap',
            },
            fields: [
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: '',
                    placeholder: 'Name',
                    name: 'client_name',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message:
                        'PLEASE ENTER A PHONE NUMBER THAT HAS AT LEAST 9 DIGITS.',
                    label: '',
                    placeholder: 'Phone number',
                    name: 'client_phone',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: "I'M INTERESTED IN...",
                    default_value: '',
                    name: 'subject',
                    type: 'select-field',
                    options: [
                        { title: 'SKIPS', value: 'SKIPS' },
                        { title: 'JUNK REMOVAL', value: 'JUNK REMOVAL' },
                        { title: 'COMMERCIAL', value: 'COMMERCIAL' },
                        {
                            title: 'SINGLE ITEM REMOVAL',
                            value: 'SINGLE ITEM REMOVAL',
                        },
                        { title: 'SKIP BAGS', value: 'SKIP BAGS' },
                    ],
                },
                {
                    required: false,
                    error: false,
                    error_message: '',
                    label: 'Please select if you would like to receive promotions and special offers:',
                    name: 'preferences',
                    type: 'checkboxes',
                    options: [
                        { title: 'SMS', name: 'allow_mk_sms', value: false },
                    ],
                },
            ],
        },
    },
    ie: {
        id: 3,
        api_url: 'https://kollect.serviceos.com',
        token: 'ephvoioojo3wx4o66a0sgz7klc45wxp60qlqdq3mtqyiu67bbcm6zjo7mscrbsqj',
        source_abbr: 'Kollect_site_callback_IE',
        validation: {
            subject: /([^\s])/,
            client_name: /^(?!\s*$)[a-zA-Z.+\s\'-]+$/,
            client_phone:
                /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/,
            client_email:
                /([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,})+/i,
            client_postcode: /^(?=.*\S).+$/,
            comment: /([^\s])/,
        },
        captcha: {
            type: 'google',
            settings: {
                google: {
                    g_key: '6LcGE5gaAAAAAE4ba40iPqbxyMGyTCc9MZ5upScN',
                    script: 'https://www.google.com/recaptcha/api.js',
                },
            },
        },
        layout: {
            type: 'side',
            title: 'Request a Quote',
            submit_text: 'Thanks for submitting the form.',
            button_text: 'Submit',
            description: '',
            footer_text: '',
            theme: {
                class: 'test-class',
                primary: '#f26930',
                primaryContrastText: '#fff',
                accent: '#f26930',
                accentContrastText: '#fff',
                text: '#ffffff',
                background: '#2e3c50',
                fieldsType: 'bootstrap',
            },
            fields: [
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'NAME',
                    placeholder: 'Name',
                    name: 'client_name',
                    type: 'text-field',
                },
                {
                    required: false,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS FIELD.',
                    label: 'EMAIL',
                    name: 'client_email',
                    placeholder: 'Email',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message:
                        'PLEASE ENTER A PHONE NUMBER THAT HAS AT LEAST 9 DIGITS.',
                    label: 'NUMBER',
                    placeholder: 'Phone number',
                    name: 'client_phone',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: 'CITY/TOWN',
                    placeholder: 'City',
                    name: 'client_postcode',
                    type: 'text-field',
                },
                {
                    required: true,
                    error: false,
                    error_message: 'PLEASE COMPLETE THIS REQUIRED FIELD.',
                    label: "I'M INTERESTED IN...",
                    default_value: '',
                    name: 'subject',
                    type: 'select-field',
                    options: [
                        { title: 'SKIPS', value: 'SKIPS' },
                        { title: 'JUNK REMOVAL', value: 'JUNK REMOVAL' },
                        { title: 'COMMERCIAL', value: 'COMMERCIAL' },
                        {
                            title: 'SINGLE ITEM REMOVAL',
                            value: 'SINGLE ITEM REMOVAL',
                        },
                        { title: 'SKIP BAGS', value: 'SKIP BAGS' },
                    ],
                },
                {
                    required: false,
                    error: false,
                    error_message: '',
                    label: 'Please select how you would like to receive promotions and special offers:',
                    name: 'preferences',
                    type: 'checkboxes',
                    options: [
                        { title: 'SMS', name: 'allow_mk_sms', value: false },
                        {
                            title: 'Email',
                            name: 'allow_mk_email',
                            value: false,
                        },
                    ],
                },
            ],
        },
    },
};
